import { useGetInternalUtilizationQuery } from '../../api/internal';
import { useDateRange } from '../../hooks/useDateRange';

// Months are counted in the viewer's timezone, as the dashboard has always shown them
export function useUtilization(dateRange: [Date, Date] | null, includeNewPatients: boolean) {
  const { dateFrom, dateTo } = useDateRange(dateRange);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return useGetInternalUtilizationQuery({ dateFrom, dateTo, timezone, includeNewPatients });
}
